.entry {
  min-inline-size: 0;
  overflow-wrap: anywhere;
}

.title {
  min-inline-size: 0;
}
